import {
    getCourses,
    getCoursesSubjectsByTeam,
    getCoursesSubjects,
    getLessonsCount,
} from '@yandex-int/k-common/client/api';
import { type Course, type FullCourseSubject, LESSONS_TYPES } from '@yandex-int/k-common/typings';
import { showNetworkError, type SUBJECTS_SLUGS_TYPE } from 'platform-components';
import { call, put, takeEvery, takeLatest, all } from 'redux-saga/effects';

import { setWizardVariables } from 'common.components/user/actions';
import { HAS_FINISHED_LESSONS } from 'common.components/user/user.constants';

import { actions } from './actions';
import { LessonsCount } from './typings';

export function* coursesBySubjectsSagasWatcher() {
    yield all([
        takeLatest(actions.getCoursesByTeamRequest, getCoursesByTeamSaga),
        takeLatest(actions.getCoursesSubjectsByTeamRequest, getCoursesSubjectsByTeamSaga),
        takeEvery(actions.getLessonsCountRequest, getLessonsCountSaga),
        takeEvery(actions.getCoursesSubjectsRequest, getCoursesSubjectsSaga),
    ]);
}

function* getCoursesByTeamSaga(action: ReturnType<typeof actions.getCoursesByTeamRequest>) {
    const { teamId } = action.payload;

    try {
        const courses: Course[] = yield call(getCourses, teamId);
        yield put(actions.getCoursesByTeamSuccess({ teamId, courses }));
    } catch (error) {
        console.error(error);

        yield put(actions.getCoursesByTeamError({ teamId }));
        yield put(showNetworkError(error));
    }
}

function* getCoursesSubjectsByTeamSaga(action: ReturnType<typeof actions.getCoursesSubjectsByTeamRequest>) {
    const { teamId } = action.payload;

    try {
        const coursesSubjects: Array<FullCourseSubject> = yield call(getCoursesSubjectsByTeam, teamId);
        yield put(actions.getCoursesSubjectsByTeamSuccess({ teamId, coursesSubjects }));
    } catch (error) {
        console.error(error);

        yield put(actions.getCoursesSubjectsByTeamError({ teamId }));
        yield put(showNetworkError(error));
    }
}

/** Получить слаги предметов открытых учительских курсов */
function* getCoursesSubjectsSaga() {
    try {
        const subjects: SUBJECTS_SLUGS_TYPE[] = yield call(getCoursesSubjects);
        yield put(actions.getCoursesSubjectsSuccess({ subjects }));
    } catch (error) {
        console.error(error);
    }
}

function* getLessonsCountSaga(action: ReturnType<typeof actions.getLessonsCountRequest>) {
    try {
        const { courseId } = action.payload;

        const lessonsCount: LessonsCount = yield call(getLessonsCount, courseId);

        yield put(actions.getLessonsCountSuccess({ courseId, counts: lessonsCount }));

        const activeOrFinishedCounts = lessonsCount[LESSONS_TYPES.ACTIVE] || lessonsCount[LESSONS_TYPES.FINISHED] || 0;
        const hasFinishedLessons = Boolean(lessonsCount[LESSONS_TYPES.FINISHED]);

        if (hasFinishedLessons) {
            yield put(setWizardVariables({ [HAS_FINISHED_LESSONS]: true }));
        }

        if (activeOrFinishedCounts > 0) {
            yield put(setWizardVariables({ studentsHaveAnswered: true }));
        }
    } catch (error) {
        console.error(error);

        yield put(showNetworkError(error));
    }
}
